import { Link, useLocation } from 'react-router-dom';
import React, { useContext, useState } from 'react';
import { LayoutDashboard, UserPlus, BarChart3, LogOut, Menu, X, ShieldCheck, Award } from 'lucide-react';
import { AuthContext } from "../../context/Auth";

const NAV_LINKS = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admins', label: 'Admins', icon: UserPlus },
  { to: '/ambassadors', label: 'Embaixadoras', icon: Award },
  { to: '/reports', label: 'Relatórios', icon: BarChart3 },
];

export const Sidebar = () => {
  const { signOut } = useContext(AuthContext);
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (to) => location.pathname === to;

  const navItemClass = (to) =>
    `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
      isActive(to) ? 'bg-accent-light text-accent' : 'text-gray-700 hover:bg-gray-50'
    }`;

  return (
    <>
      {/* Topbar mobile */}
      <header className="lg:hidden fixed top-0 left-0 z-40 flex w-full items-center justify-between border-b border-gray-200 bg-white px-4 py-3 shadow-sm">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-accent text-white">
            <ShieldCheck className="h-4 w-4" />
          </div>
          <span className="text-sm font-semibold text-gray-900">Agendix Admin</span>
        </div>
        <button
          onClick={() => setMobileOpen(true)}
          className="rounded-md p-2 text-gray-600 hover:bg-gray-100"
        >
          <Menu className="h-5 w-5" />
        </button>
      </header>

      {/* Drawer mobile */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 flex lg:hidden">
          <div className="absolute inset-0 bg-black/30" onClick={() => setMobileOpen(false)} />
          <div className="relative flex w-64 flex-col bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
              <span className="text-sm font-semibold text-gray-900">Agendix Admin</span>
              <button onClick={() => setMobileOpen(false)} className="text-gray-400 hover:text-gray-600">
                <X className="h-5 w-5" />
              </button>
            </div>
            <nav className="flex-1 space-y-1 p-3">
              {NAV_LINKS.map(({ to, label, icon: Icon }) => (
                <Link key={to} to={to} className={navItemClass(to)} onClick={() => setMobileOpen(false)}>
                  <Icon className="h-4 w-4" />
                  {label}
                </Link>
              ))}
            </nav>
            <div className="border-t border-gray-200 p-3">
              <button
                onClick={signOut}
                className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                <LogOut className="h-4 w-4" /> Sair
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="lg:hidden h-14" />

      {/* Sidebar desktop */}
      <section className="hidden lg:relative lg:flex lg:w-64 lg:flex-shrink-0 lg:flex-col lg:border-r lg:border-gray-200 lg:bg-white lg:shadow-md">
        <div className="flex items-center gap-2 border-b border-gray-200 px-4 py-4">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-accent text-white">
            <ShieldCheck className="h-4 w-4" />
          </div>
          <span className="text-sm font-semibold text-gray-900">Agendix Admin</span>
        </div>
        <nav className="flex-1 space-y-1 p-3">
          {NAV_LINKS.map(({ to, label, icon: Icon }) => (
            <Link key={to} to={to} className={navItemClass(to)}>
              <Icon className="h-4 w-4" />
              {label}
            </Link>
          ))}
        </nav>
        <div className="border-t border-gray-200 p-3">
          <button
            onClick={signOut}
            className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            <LogOut className="h-4 w-4" /> Sair
          </button>
        </div>
      </section>
    </>
  );
}
